import axios from "axios";
import { firebaseAuth } from "../config/firebase";
import { API_URL } from "../helpers/variables";

const api = axios.create({
  timeout: 10000,
  baseURL: API_URL,
});

api.interceptors.request.use(async (config) => {
  const token = await firebaseAuth.currentUser.getIdToken();

  config.headers = {
    ...config.headers,
    Authorization: `bearer ${token}`,
  };

  return config;
});

export default api;
